<ion-content class="invite-page">
  <div class="inv-wrapper">

    @if (invalidLink) {
    <div class="inv-card">
      <div class="inv-icon-ring">
        <ion-icon color="light" name="alert-circle-outline"></ion-icon>
      </div>
      <h1 class="inv-title">{{ 'mainauth.invite.invalidTitle' | translate }}</h1>
      <p class="inv-body">{{ 'mainauth.invite.invalidBody' | translate }}</p>
      <a class="inv-link" href="mailto:support&#64;gastro-management.ch">support&#64;gastro-management.ch</a>
    </div>
    } @else {
    <div class="inv-card">
      <div class="inv-icon-ring">
        <ion-icon color="light" name="mail-open-outline"></ion-icon>
      </div>

      <h1 class="inv-title">{{ 'mainauth.invite.title' | translate }}</h1>

      @if (organizationName) {
      <p class="inv-org">{{ organizationName }}</p>
      }

      <p class="inv-body">{{ 'mainauth.invite.body' | translate }}</p>

      <button class="inv-cta" (click)="accept()" [disabled]="redirecting">
        @if (redirecting) {
        <ion-spinner name="crescent"></ion-spinner>
        {{ 'mainauth.invite.redirecting' | translate }}
        } @else {
        <ion-icon name="arrow-forward-outline"></ion-icon>
        {{ 'mainauth.invite.cta' | translate }}
        }
      </button>

      <p class="inv-hint">{{ 'mainauth.invite.hint' | translate }}</p>
    </div>
    }

  </div>
</ion-content>
